import * as apiService from "./v2/apiService";
import { baseURL } from "@/constants/v2/endPoints";

export async function getMyPlans() {
  return await apiService.apiCall(`${baseURL}api/v2/plans/me`, "GET", {});
}

export async function requestProFromBroker(note) {
  return await apiService.apiCall(`${baseURL}api/v2/plans/pro-requests`, "POST", note ? { note } : {});
}

export async function getMyProRequest() {
  return await apiService.apiCall(`${baseURL}api/v2/plans/pro-requests/mine`, "GET", {});
}
